<!--FUNZIONA ATTRAVERSO VUEX IN MODO DA GESTIRLO FUORI IL ROUTER-->
<template>
  <div class="text-center">
    <v-dialog v-model="dialog_show" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{dialog_title}}</v-card-title>

        <v-card-text class="pt-4 pb-4" v-html="dialog_text">
          
          </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="hideDialog">Chiudi</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ModalDialog",
  computed: {
    dialog_show: function() {
      return this.$store.state.modal.visible;
    },
    dialog_text: function() {
      return this.$store.state.modal.text;
    },
    dialog_title: function() {
      return this.$store.state.modal.title;
    }
  },
  data() {
    return {};
  },
  created() {

  },
  methods: {
    hideDialog() {
      this.$store.state.modal.visible = false;
    }
  }
};
</script>